// @flow

import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';

import {
  addApplicationLoader,
  removeApplicationLoader,
  hideFlashBanner,
  setActiveTab,
} from 'actions/application';

import {
  postTutorResetPasswordEmailRequest,
  postTutorResetPasswordEmailSuccess,
  postTutorResetPasswordEmailFailure,
  postTutorPasswordRequest,
  postTutorPasswordSuccess,
  postTutorPasswordFailure,
  postTutorSignInRequest,
  postTutorSignInSuccess,
  postTutorSignInFailure,
} from 'actions/tutor';

import {
  postSessionCreateRequest,
  postSessionCreateSuccess,
  postSessionCreateFailure,
  putSessionReportRequest,
  putSessionReportSuccess,
  putSessionReportFailure,
  putSessionCancelRequest,
  putSessionCancelSuccess,
  putSessionCancelFailure,
  putSessionDeleteRequest,
  putSessionDeleteSuccess,
  putSessionDeleteFailure,
} from 'actions/sessions';

import {
  getPayerAuthenticatedRequest,
  getPayerAuthenticatedSuccess,
  getPayerAuthenticatedFailure,
  getNewPayerAuthenticatedRequest,
  getNewPayerAuthenticatedSuccess,
  getNewPayerAuthenticatedFailure,
  postPayerPaymentMethodRequest,
  postPayerPaymentMethodSuccess,
  postPayerPaymentMethodFailure,
  postPayerChargeConfirmationRequest,
  postPayerChargeConfirmationSuccess,
  postPayerChargeConfirmationFailure,
  getPayerRequest,
  getPayerSuccess,
  getPayerFailure,
} from 'actions/payer';

type StateType = {
  activeTab: number,
  flash: any,
  isLoading: number,
};

const initialState: StateType = {
  activeTab: 0,
  isLoading: 0,
  flash: null,
};

const setActive = (state: StateType, action): StateType => ({
  ...state,
  activeTab: action.payload,
});

const isLoadingTrue = state => ({
  ...state,
  isLoading: state.isLoading + 1,
});

const isLoadingFalse = state => ({
  ...state,
  isLoading: state.isLoading < 1 ? 0 : state.isLoading - 1,
});

const hideFlash = state => ({
  ...state,
  flash: null,
});

const showFlash = (state, action) => ({
  ...state,
  isLoading: state.isLoading < 1 ? 0 : state.isLoading - 1,
  flash: {
    type: action.type,
    ...action.payload,
  },
});

export default handleActions<any, any>(
  {
    [hideFlashBanner.toString()]: hideFlash,
    [setActiveTab.toString()]: setActive,

    [postTutorSignInRequest.toString()]: isLoadingTrue,
    [postTutorSignInSuccess.toString()]: isLoadingFalse,
    [postTutorSignInFailure.toString()]: showFlash,

    [postTutorResetPasswordEmailRequest.toString()]: isLoadingTrue,
    [postTutorResetPasswordEmailSuccess.toString()]: showFlash,
    [postTutorResetPasswordEmailFailure.toString()]: showFlash,

    [postTutorPasswordRequest.toString()]: isLoadingTrue,
    [postTutorPasswordSuccess.toString()]: showFlash,
    [postTutorPasswordFailure.toString()]: showFlash,

    [postSessionCreateRequest.toString()]: isLoadingTrue,
    [postSessionCreateSuccess.toString()]: isLoadingFalse,
    [postSessionCreateFailure.toString()]: showFlash,

    [getPayerAuthenticatedRequest.toString()]: isLoadingTrue,
    [getPayerAuthenticatedSuccess.toString()]: isLoadingFalse,
    [getPayerAuthenticatedFailure.toString()]: isLoadingFalse,

    [getNewPayerAuthenticatedRequest.toString()]: isLoadingTrue,
    [getNewPayerAuthenticatedSuccess.toString()]: isLoadingFalse,
    [getNewPayerAuthenticatedFailure.toString()]: isLoadingFalse,

    [postPayerPaymentMethodRequest.toString()]: isLoadingTrue,
    [postPayerPaymentMethodSuccess.toString()]: isLoadingFalse,
    [postPayerPaymentMethodFailure.toString()]: showFlash,

    [postPayerChargeConfirmationRequest.toString()]: isLoadingTrue,
    [postPayerChargeConfirmationSuccess.toString()]: isLoadingFalse,
    [postPayerChargeConfirmationFailure.toString()]: showFlash,

    [getPayerRequest.toString()]: isLoadingTrue,
    [getPayerSuccess.toString()]: isLoadingFalse,
    [getPayerFailure.toString()]: showFlash,

    [putSessionReportRequest.toString()]: isLoadingTrue,
    [putSessionReportSuccess.toString()]: isLoadingFalse,
    [putSessionReportFailure.toString()]: showFlash,

    [putSessionCancelRequest.toString()]: isLoadingTrue,
    [putSessionCancelSuccess.toString()]: showFlash,
    [putSessionCancelFailure.toString()]: showFlash,

    [putSessionDeleteRequest.toString()]: isLoadingTrue,
    [putSessionDeleteSuccess.toString()]: isLoadingFalse,
    [putSessionDeleteFailure.toString()]: showFlash,

    [addApplicationLoader.toString()]: isLoadingTrue,
    [removeApplicationLoader.toString()]: isLoadingFalse,

    [LOCATION_CHANGE]: hideFlash,
  },
  initialState,
);



// WEBPACK FOOTER //
// ./src/reducers/application.js